import Vue from 'vue'
import App from '@/models/App'
import Ship from '@/models/Ship'
import Organization from '@/models/Organization'

export default class ShipLogBook extends App {
    static get entity() {
        return 'ShipLogBooks'
    }
    static findById(id) {
        return this.query().whereId(id).withAllRecursive().first()
    }
    static fetchByType(type) {
        return this.query()
            .withAllRecursive()
            .where('type', type)
            .orderBy('id', 'desc')
            .get()
    }
    static all() {
        return this.query().withAllRecursive().orderBy('id', 'desc').get()
    }
    static fields() {
        return {
            id: this.uid(),
            organizationId: this.attr(''),
            shipId: this.attr(''),
            type: this.attr(''),
            voyageNo: this.attr(''),
            openedAt: this.attr(''),
            closedAt: this.attr(''),
            dockedAt: this.attr(''),
            openedTimezone: this.attr(0),
            closedTimezone: this.attr(0),
            place: this.attr(''),
            departurePort: this.attr(''),
            arrivelPort: this.attr(''),
            elapsedTime: this.attr(''),
            organization: this.belongsTo(Organization, 'organizationId'),
            ship: this.belongsTo(Ship, 'shipId'),
        }
    }
    static apiConfig = {
        actions: {
            fetch(shipId, params) {
                return this.get(`${shipId}/logbooks`, {
                    params: App.get(params),
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
            find(shipId, logBookId, params) {
                return this.get(`${shipId}/logbooks/${logBookId}`, {
                    params: App.get(params),
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'logbook',
                    baseURL: App.apiURL(),
                })
            },
            create(shipId, params) {
                return this.post(`${shipId}/logbooks`, App.post(params), {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'logbook',
                    baseURL: App.apiURL(),
                })
            },
            update(shipId, logbookId, params) {
                return this.patch(
                    `${shipId}/logbooks/${logbookId}`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'logbook',
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
